import CascadeTree from './CascadeTree';

// export types
export type { CascadeTreeProps } from './types';

// export components
export { CascadeTree };
export default CascadeTree;
